import sortByArrayUtil from 'packages/src/modules/array/sort-by/index.js'

/**
 * Sorts an array of strings by alphabetical order.
 * e.g. ['test', 'aha', 'haha'] => ['aha', 'haha', 'test']
 * @param  {String[]} arr
 * @returns {String[]}
 */
function sortByAlphabeticalOrder (arr) {
  return sortByArrayUtil(arr, w => w.toLowerCase())
}

export {
  sortByAlphabeticalOrder
}
